module.exports = __webpack_public_path__ + "static/media/Login_Page_Autonomiq_Logo.c824058d.svg";